import React from "react";
import {CalcTabsArea, CalcPageCard, CalcWideCardColumn} from "./styles";
import Soros from "./Soros";
import Martingale from "./Martingale";
import JurosCompostos from "./JurosCompostos";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Porcentagem from "./Porcentagem";
import DivDiagonal from "../../components/DivDiagonal";
import {TradingWrapper, ContentArea} from "../Trading/styles";
import {StrategyPageHeader} from "../Strategy/styles";

export default function Calculadora() {
    const { t } = useTranslation();
    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal/>
                    <ContentArea>
                        <StrategyPageHeader>
                            <h1>
                                <i className="fa fa-calculator" aria-hidden="true"/>
                                {' '}{t('calc_card_title')}
                            </h1>
                        </StrategyPageHeader>

                        <CalcWideCardColumn>
                            <CalcPageCard>
                                <CalcTabsArea>
                                    <ul className="nav nav-tabs nav-tabs-calc" id="calcTab" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className="nav-link active"
                                                id="porcentagem-tab"
                                                data-toggle="tab"
                                                href="#porcentagem"
                                                role="tab"
                                                aria-controls="porcentagem"
                                                aria-selected="true"
                                            >
                                                {t('calc_tab_percentage')}
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="nav-link"
                                                id="juros-tab"
                                                data-toggle="tab"
                                                href="#juros"
                                                role="tab"
                                                aria-controls="juros"
                                                aria-selected="false"
                                            >
                                                {t('calc_tab_compound_interest')}
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="nav-link"
                                                id="martingale-tab"
                                                data-toggle="tab"
                                                href="#martingale"
                                                role="tab"
                                                aria-controls="martingale"
                                                aria-selected="false"
                                            >
                                                {t('calc_tab_martingale')}
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="nav-link"
                                                id="soros-tab"
                                                data-toggle="tab"
                                                href="#soros"
                                                role="tab"
                                                aria-controls="soros"
                                                aria-selected="false"
                                            >
                                                {t('calc_tab_soros')}
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="calcTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="porcentagem"
                                            role="tabpanel"
                                            aria-labelledby="porcentagem-tab"
                                        >
                                            <Porcentagem/>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="juros"
                                            role="tabpanel"
                                            aria-labelledby="juros-tab"
                                        >
                                            <JurosCompostos/>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="martingale"
                                            role="tabpanel"
                                            aria-labelledby="martingale-tab"
                                        >
                                            <Martingale/>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="soros"
                                            role="tabpanel"
                                            aria-labelledby="soros-tab"
                                        >
                                            <Soros/>
                                        </div>
                                    </div>
                                </CalcTabsArea>
                            </CalcPageCard>
                        </CalcWideCardColumn>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
